import React from 'react'
import { useNavigate } from 'react-router-dom'
import BotWelcomeImage from '@/assets/bot-welcome-image.webp'
import { Button, Column, Row, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'
import { useAuth } from '@/contexts/AuthContext.tsx'
import { ROUTES } from '@/types/routes.ts'

const WelcomeState: React.FC = () => {
  const navigate = useNavigate()
  const { student } = useAuth()

  return (
    <AvatarCard variant="image" botAvatar={BotWelcomeImage} animate={false}>
      <Column className="h-full flex-1 justify-between space-y-4">
        <Column className="space-y-5">
          <Text color="600" size="xl" align="center">
            <Text.Translated translationKey="welcome_message_setup_states_welcome" />{' '}
            {student?.name && (
              <Text
                color="600"
                size="xl"
                align="center"
                fontWeight="bold"
                transform="capitalize"
              >
                {student?.name}!
              </Text>
            )}
          </Text>
          <Text color="600" className="max-sm:text-base">
            <Text.Translated
              className="inline"
              translationKey="julia_introduction_setup_states_welcome"
            />{' '}
            <Text.Translated
              color="600"
              fontWeight="bold"
              className="inline max-sm:text-base"
              translationKey="fluency_test_setup_states_welcome"
            />{' '}
            <Text.Translated
              className="inline"
              translationKey="setup_message_setup_states_welcome"
            />
          </Text>
        </Column>
        <Row className="w-full self-center sm:max-w-[200px]">
          <Button.Translated
            translationKey="next_button_setup_states_welcome"
            grow
            onClick={() => navigate(ROUTES.ONBOARDING.LISTENING_TEST)}
          />
        </Row>
      </Column>
    </AvatarCard>
  )
}

export default WelcomeState
